import { render, staticRenderFns } from "./addCategory.vue?vue&type=template&id=3f4b5d76&"
import script from "./addCategory.vue?vue&type=script&lang=js&"
export * from "./addCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports